import Stats from 'stats.js'

export default class Statistics {
  constructor () {
    this.stats = new Stats()
    document.body.appendChild(this.stats.dom)
  }
}
